import React from "react";
import PropTypes from "prop-types";
import Skeleton from "./Skeleton";

export default function AvatarSkeleton({
  size = 40,
  shape = "circle",
  className = "",
  style = {},
  ...rest
}) {
  const radius = shape === "circle" ? "9999px" : 8;

  return (
    <Skeleton
      variant={shape === "circle" ? "circular" : "rounded"}
      width={size}
      height={size}
      radius={radius}
      className={`app-skeleton-avatar ${className}`.trim()}
      style={style}
      {...rest}
    />
  );
}

AvatarSkeleton.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  shape: PropTypes.oneOf(["circle", "rounded"]),
  className: PropTypes.string,
  style: PropTypes.object,
};
